import { parseQueryString } from '@/lib/auth/parseQueryString'
import client from '../lib/request'

export default {
  authUser(authSearchParams: string) {
    const body = parseQueryString(authSearchParams)
    return client.post<{
      status: number
      finished_steps: string
      completed_guide: number
      token: string
      url: string
    }>('admin/auth', body)
  },
  login(param = {}) {
    return client.post('admin/login', param)
  },
  fixFunction(param = {}) {
    return client.post('fixFunction', param)
  },
  appEmbed(param = {}) {
    return client.post('appEmbed', param)
  },
  updSetupGuideStatus(param: { guide_type: number; status: number }) {
    return client.post('updSetupGuideStatus', param)
  },
}
